export default "__VITE_ASSET__B0LKG6VG__"